import { FC } from 'react';
import { faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoanOfficerDetailDto, PartnerDto } from '../openapi/atlantis';
import { formatPhoneNumber } from '../utils/StringUtils';
import AvatarV2 from './AvatarV2';
import IconText from './IconText';

export interface PartnerProfileCardProps {
  authorizedPerson: Partial<LoanOfficerDetailDto & PartnerDto>;
  isLoanOfficer?: boolean;
  isPartner?: boolean;
}

const PartnerProfileCard: FC<PartnerProfileCardProps> = ({
  authorizedPerson,
  isLoanOfficer = false,
  isPartner = false,
}) => {
  const fullName = `${authorizedPerson?.firstName || ''} ${
    authorizedPerson?.lastName || ''
  }`.trim();

  const phoneClickHandler = () => {
    if (authorizedPerson?.phoneNumber) {
      window.open(`tel:${authorizedPerson.phoneNumber}`);
    }
  };

  const nmlsNumber = authorizedPerson?.nmlsNumber;

  return (
    <div className='flex flex-col gap-2 lg:gap-3 bg-reskin-midnight-green-800 p-6 lg:py-6 lg:px-11 h-full rounded-[30px] lg:w-3/6 w-full'>
      <div className='flex items-start'>
        <AvatarV2 name={fullName} imageUrl={authorizedPerson?.avatar} />
      </div>
      <div className='text-left'>
        <p className='font-inter font-light lg:font-medium text-sm lg:text-2xl text-white mt-1.5'>
          {fullName}
        </p>
        {isLoanOfficer && (
          <>
            <p className='text-sm font-inter font-light text-reskin-regent-400 mt-1.5'>
              Mortgage Advisor
              {nmlsNumber && ` - NMLS: #${nmlsNumber}`}
            </p>
            <p className='text-xs font-inter font-light text-reskin-regent-400 mt-1.5'>
              One Real Mortgage Corp. NMLS 198414
            </p>
          </>
        )}

        {isPartner && (
          <p className='text-sm font-inter font-light text-reskin-regent-400 mt-1.5'>
            Agent | The Real Brokerage
          </p>
        )}

        <div className='pt-4 flex flex-col gap-2'>
          {authorizedPerson?.emailAddress && (
            <IconText
              onClick={() => {
                window.open(`mailto:${authorizedPerson.emailAddress}`);
              }}
              icon={faEnvelope}
              label={authorizedPerson.emailAddress}
              containerStyle='gap-2.5'
              labelStyle='truncate'
            />
          )}
          {authorizedPerson?.phoneNumber && (
            <IconText
              onClick={phoneClickHandler}
              icon={faPhone}
              label={formatPhoneNumber(authorizedPerson.phoneNumber)}
              containerStyle='gap-2.5'
            />
          )}
        </div>

        <div className='pt-4 flex flex-row gap-3'>
          {authorizedPerson?.facebookURL && (
            <FontAwesomeIcon
              icon={faFacebook}
              fontSize={15}
              className='text-white cursor-pointer'
              onClick={() => {
                window.open(authorizedPerson.facebookURL, '_blank');
              }}
            />
          )}
          {authorizedPerson?.instagramURL && (
            <FontAwesomeIcon
              icon={faInstagram}
              fontSize={15}
              className='text-white cursor-pointer'
              onClick={() => {
                window.open(authorizedPerson.instagramURL, '_blank');
              }}
            />
          )}
          {authorizedPerson?.linkedInURL && (
            <FontAwesomeIcon
              icon={faLinkedin}
              fontSize={15}
              className='text-white cursor-pointer'
              onClick={() => {
                window.open(authorizedPerson.linkedInURL, '_blank');
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnerProfileCard;
